"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _v = _interopRequireDefault(require("uuid/v4"));

var LoudspeakerList = function LoudspeakerList(_ref) {
  var announcements = _ref.announcements,
      channelId = _ref.channelId,
      hideViewAllAnnouncementsButton = _ref.hideViewAllAnnouncementsButton,
      language = _ref.language,
      defaultFallbackLanguage = _ref.defaultFallbackLanguage,
      initializedTimestamp = _ref.initializedTimestamp,
      t = _ref.t; // Links that point to an external URL should open in a new tab

  var setTargetAttribute = function setTargetAttribute(url) {
    if (url) {
      var link = document.createElement('a');
      link.href = url;

      if (link.hostname !== window.location.hostname) {
        return '_blank';
      }
    }

    return undefined;
  };

  var renderAnnouncementTags = function renderAnnouncementTags(tags) {
    var displayFormattedTags = tags.map(function (_ref2) {
      var key = _ref2.key,
          _ref2$value = _ref2.value,
          value = _ref2$value === void 0 ? '' : _ref2$value;
      return _react.default.createElement("div", {
        className: "loudspeakerAnnouncement__tag",
        key: key
      }, _react.default.createElement("i", {
        className: "fa fa-tag loudspeakerAnnouncement__tagIcon"
      }), value);
    });
    return _react.default.createElement("div", {
      className: "loudspeakerAnnouncement__tags"
    }, displayFormattedTags);
  };

  var openedAllAnnouncementsPage = function openedAllAnnouncementsPage() {
    var clickedViewAllTimestamp = new Date().getTime();

    _reactGa.default.ga('reactLoudspeaker.send', 'event', 'reactLoudspeaker', 'Clicked view all announcements link');

    _reactGa.default.ga('reactLoudspeaker.send', 'timing', 'reactLoudspeaker', 'Clicked view all announcements link', clickedViewAllTimestamp - initializedTimestamp);
  };

  var renderAnnouncementWithOnlyContent = function renderAnnouncementWithOnlyContent(content, tags) {
    var translatedContent = content[language] || content[defaultFallbackLanguage];
    var announcementTags;
    var announcementContentStyling = 'loudspeakerAnnouncement__contentOnly';

    if (tags && tags.length) {
      announcementContentStyling += ' loudspeakerAnnouncement__contentOnly--withTags';
      announcementTags = renderAnnouncementTags(tags);
    }

    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
      className: announcementContentStyling
    }, _react.default.createElement(_reactMarkdown.default, {
      source: translatedContent,
      linkTarget: setTargetAttribute
    })), announcementTags);
  };

  var renderAnnouncementWithTitleAndSnippet = function renderAnnouncementWithTitleAndSnippet(announcement) {
    var title = announcement.title,
        snippet = announcement.snippet,
        announcementId = announcement.announcementId,
        tags = announcement.tags;
    var announcementTags;
    var readMoreLinkStyling = 'loudspeakerAnnouncement__readMoreLink';

    if (tags && tags.length) {
      readMoreLinkStyling += ' loudspeakerAnnouncement__readMoreLink--withTags';
      announcementTags = renderAnnouncementTags(tags);
    }

    var readMoreLink = _react.default.createElement("a", {
      className: readMoreLinkStyling,
      href: "https://loudspeaker.fi.cimpress.io/channels/".concat(channelId, "/allannouncements/").concat(announcementId),
      target: "_blank",
      rel: "noopener noreferrer"
    }, t('readMoreAllAnnouncementsLink'));

    var announcementTitle;
    var announcementSnippet;

    if (title) {
      announcementTitle = title[language] || title[defaultFallbackLanguage];
    }

    if (snippet) {
      announcementSnippet = snippet[language] || snippet[defaultFallbackLanguage];
    }

    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h5", {
      className: "loudspeakerAnnouncement__title"
    }, announcementTitle), _react.default.createElement("div", {
      className: "loudspeakerAnnouncement__snippet"
    }, announcementSnippet), readMoreLink, announcementTags);
  };

  var listItems = announcements.map(function (announcement) {
    var displayedAnnouncements;
    var snippet = announcement.snippet,
        title = announcement.title,
        content = announcement.content,
        announcementId = announcement.announcementId,
        tags = announcement.tags;

    if (snippet || title) {
      displayedAnnouncements = renderAnnouncementWithTitleAndSnippet({
        title: title,
        snippet: snippet,
        announcementId: announcementId,
        tags: tags
      });
    } else if (content[language] || content[defaultFallbackLanguage]) {
      displayedAnnouncements = renderAnnouncementWithOnlyContent(content, tags);
    } else {
      return null;
    }

    return _react.default.createElement("div", {
      className: "loudspeakerAnnouncement",
      key: (0, _v.default)()
    }, displayedAnnouncements);
  });

  if (!hideViewAllAnnouncementsButton) {
    listItems.push(_react.default.createElement("div", {
      className: "loudspeakerViewAllButton",
      key: (0, _v.default)()
    }, _react.default.createElement("div", {
      className: "loudspeakerViewAllButton__content"
    }, _react.default.createElement("a", {
      className: "loudspeakerViewAllButton__link",
      href: "https://loudspeaker.fi.cimpress.io/channels/".concat(channelId, "/allannouncements"),
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: openedAllAnnouncementsPage
    }, t('viewAllAnnouncementsText')))));
  }

  return _react.default.createElement(_react.default.Fragment, null, listItems);
};

LoudspeakerList.propTypes = {
  announcements: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.shape({
      en: _propTypes.default.string,
      de: _propTypes.default.string,
      fr: _propTypes.default.string
    }).isRequired,
    snippet: _propTypes.default.shape({
      en: _propTypes.default.string,
      de: _propTypes.default.string,
      fr: _propTypes.default.string
    }),
    title: _propTypes.default.shape({
      en: _propTypes.default.string,
      de: _propTypes.default.string,
      fr: _propTypes.default.string
    }),
    tags: _propTypes.default.arrayOf(_propTypes.default.shape({
      key: _propTypes.default.string,
      value: _propTypes.default.string
    }))
  })).isRequired,
  channelId: _propTypes.default.string,
  hideViewAllAnnouncementsButton: _propTypes.default.bool,
  language: _propTypes.default.string,
  defaultFallbackLanguage: _propTypes.default.string,
  initializedTimestamp: _propTypes.default.number.isRequired,
  t: _propTypes.default.func.isRequired
};
LoudspeakerList.defaultProps = {
  hideViewAllAnnouncementsButton: true,
  channelId: '',
  language: 'en',
  defaultFallbackLanguage: 'en'
};
var _default = LoudspeakerList;
exports.default = _default;